import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import EditTemplateRevision from "../../../../components/AssetManagement/Design/Templates/EditTemplateRevision/EditTemplateRevision";
import store from "../../../../store";
import { setSiteOptions } from "../../../../features/templateSlice";
import { selectUserData, selectUserToken } from "../../../../features/userSlice";
import { DesignTemplatesEndPointLogic } from "../../../../logic/AssetManagement/Design/Templates/DesignTemplatesEndPointLogic";

/**
 * Screen for the redesigned Edit Template UI (GR-21832).
 * Seeds the same Redux state the existing Edit screen relies on, so the screen
 * works on a refresh or a direct link as well as via the Templates list.
 */
const EditTemplateRevisionScreen = () => {
  const response = useSelector(selectUserData);
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const websiteSharedUid = searchParams.get("selectedSite") ?? "";

  useEffect(() => {
    if (response?.data?.website_permissions) {
      const siteOptions = response.data.website_permissions.map(
        (siteObj: any) => {
          const uid = Object.keys(siteObj)[0];
          const siteName = siteObj[uid].ui_site_name;
          return { uid, siteName };
        }
      );

      store.dispatch(setSiteOptions(siteOptions));
    }
  }, [response]);

  // The template list backs the "name must be unique" check, and is empty when
  // the screen is opened directly rather than from the Templates table.
  useEffect(() => {
    if (!oauthTokenHeader || !websiteSharedUid) return;

    DesignTemplatesEndPointLogic.getDesignTemplates(
      oauthTokenHeader,
      websiteSharedUid,
      dispatch
    );
  }, [oauthTokenHeader, websiteSharedUid, dispatch]);

  return <EditTemplateRevision />;
};

export default EditTemplateRevisionScreen;
